import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { VerifyEmail } from "./VerifyEmail";

/** Follow / Vote path: email verification only — no casting application. */
export const AccessModal = ({ open, onClose, signIn }) => (
  <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
    <DialogContent aria-describedby={undefined} className="bg-[#0B111B] border border-[#D4AF37]/30 text-[#F7F8F9] max-w-md" data-testid="access-modal">
      <DialogHeader>
        <DialogTitle className="font-display tracking-[0.1em] text-[#F5F3EF]">JOIN THE CREW</DialogTitle>
      </DialogHeader>
      <p className="font-editorial italic text-base text-[#94A3B8]">Follow, vote, and unlock the members-only cuts.</p>
      <VerifyEmail
        intro="Verify your email once to follow applicants, cast votes, and watch the special videos. No casting application needed."
        onVerified={(tok, m) => { signIn(tok, m); onClose(); }}
      />
    </DialogContent>
  </Dialog>
);
